import { configureStore } from "@reduxjs/toolkit";
import unreadChatMessagesReducer from "./reducers/chatReducer";

const store = configureStore({
  reducer: {
    unreadChatMessagesState: unreadChatMessagesReducer,
  }
})

export default store